<template>
  <div id="app">
    <Header v-if="$route.meta.showHeader!=false"></Header>
    <router-view class="container" />
    <!-- <Footer></Footer> -->
    <el-dialog
      title=""
      :visible.sync="$store.state.giveNameResultDialogStatus"
      :append-to-body="true"
      class="give-name-result-dialog"
    >
      <div :class="'result-status-' + resultLevel">
        <div class="result-title">
          “<span>{{ checkNameViewNew.checkName }}</span
          >” 的注册通过率
        </div>
        <ul class="clearfix result-level">
          <li><span>低</span></li>
          <li><span>中</span></li>
          <li><span>高</span></li>
        </ul>
        <div class="result-text" v-if="resultLevel === 'error'">
          通过率较低！
        </div>
        <div class="result-text" v-if="resultLevel === 'warning'">
          通过率中！
        </div>
        <div class="result-text" v-if="resultLevel === 'success'">
          通过率较高！
        </div>
        <div
          class="result-detail"
          :class="{
            [resultLevel]: resultLevel,
            'has-data': checkNameViewNew.data
          }"
        >
          <p>
            <span>{{ checkNameViewNew.message }}</span>
          </p>
          <div
            v-if="checkNameViewNew.data"
            v-html="checkNameViewNew.data[0]"
          ></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapMutations, mapState, mapActions } from "vuex";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header
  },
  computed: {
    ...mapState({
      checkNameViewNew: state => state.checkNameViewNew
    }),
    resultLevel() {
      if (this.checkNameViewNew.passRate > 66) {
        return "error";
      } else if (
        this.checkNameViewNew.passRate <= 66 &&
        this.checkNameViewNew.passRate >= 33
      ) {
        return "warning";
      }
      return "success";
    }
  },
  created() {
    this.$store.dispatch("getLocation");
    this.$store.commit("setFirstUrl", window.location.href);
    this.$store.dispatch("initLoginStatus");
  }
};
</script>
<style lang="scss">
html,
body {
  height: 100%;
}
body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  line-height: 1.6;
}
.wp {
  /*width: 100%;*/
  /*margin: 0 auto;*/
  /*overflow: hidden;*/
}
.clearfix {
  &::after {
    display: block;
    content: "";
    clear: both;
  }
}
#app {
  min-height: 100%;
  padding-bottom: 80px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  background: rgba(245, 245, 245, 1);
}
.el-dialog__title {
  color: #3b9af1;
}
.el-message {
  min-width: 80%;
  top: 18% !important;
}
.el-dialog {
  width: 88% !important;
}

.give-name-result-dialog {
  .el-dialog {
    width: 80%;
  }
  .el-dialog__body {
    padding: 20px 18px;
  }
  .result-title {
    text-align: center;
    margin-bottom: 30px;
    span {
      color: #3b9af1;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .result-level {
    margin-bottom: 40px;
    li {
      height: 15px;
      width: 33%;
      margin-right: 0.5%;
      float: left;
      position: relative;
      &:last-of-type {
        margin-right: 0;
      }
      span {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: -28px;
        text-align: center;
      }
    }
  }
  .result-text {
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .result-detail {
    line-height: 2;
    &.warning.has-data,
    &.error.has-data {
      text-align: left !important;
    }
  }
  .result-status-success {
    .result-level {
      li {
        background: #27cb70;
      }
    }
    .result-text {
      background: #18b65e;
    }
    .result-detail {
      text-align: center;
      span {
        color: #333;
      }
    }
  }
  .result-status-warning {
    .result-level {
      li {
        background: #ffd200;
        &:last-of-type {
          background: #e0e0e0;
        }
      }
    }
    .result-text {
      background: #ff9c00;
    }
    .result-detail {
      text-align: center;
      span {
        color: #ff7800;
      }
    }
  }
  .result-status-error {
    .result-level {
      li {
        background: #e0e0e0;
        &:first-of-type {
          background: #ff0000;
        }
      }
    }
    .result-text {
      background: #f11717;
    }
    .result-detail {
      text-align: center;
      span {
        color: #f11717;
      }
    }
  }
}
</style>
